import { useAppStore } from "@/stores";

/**
 * The legacy overlay's messages to the casino page (overlay/src/v2.0/utils/helpers.js
 * `sendEvent` / `sendPrizePayoutEvent`), kept call for call so a host listening for them keeps
 * working across the cutover: `window.postMessage({ source: "unibo", type, info? }, "*")`.
 *
 * - `show` / `hide`: the overlay has campaigns to dock, or none (it then takes no room).
 * - `collapse` / `expand`: the dock closed to its rail (or bar), or opened.
 * - `prizePayout`: a prize the player won was just announced to them.
 *
 * Only the overlay sends them: the widgets never did, and a host page embedding both must not
 * hear one event twice.
 */
type HostEvent =
  | { type: "show" | "hide" | "collapse" | "expand" }
  | {
      type: "prizePayout";
      /** The won prize, as legacy shaped it: the notification it came on, and the prize's
       *  title with the names of the games it is for. */
      info: { id: number; prize: { text: string; games: string[] } };
    };

const SOURCE = "unibo";

export function postHostEvent(event: HostEvent): void {
  if (useAppStore.getState().variant !== "overlay") return;
  window.postMessage({ source: SOURCE, ...event }, "*");
}

export function postPrizePayout(
  notificationId: number,
  prize: { text: string; games?: string[] }
): void {
  if (!prize.text) return;
  postHostEvent({
    type: "prizePayout",
    info: {
      id: notificationId,
      prize: { text: prize.text, games: prize.games ?? [] },
    },
  });
}
